import { Route } from 'react-router';
import PartnerPage from '../../../modules/partner';

export const PartnerRouter = [<Route index element={<PartnerPage />} />];
